
import { capitalizeFirstLetter } from "../../utils/Helper";

const messageData = {
    "enter_email_address": "Enter your email address"
}

const ValidationMessageAlbanian = {
    Field: (name: any) => `Ju lutemi shkruani tuajin ${name}.`,
    MinLength: (name: string, length: number) => `${capitalizeFirstLetter(name)} duhet të jetë të paktën ${length} personazhet.`,
    MaxLength: (name: string, length: number) => `${capitalizeFirstLetter(name)} nuk mund të kalojë më shumë se ${length} personazhet.`,
    EMAIL_ADDRESS:"Ju lutemi shkruani adresën e vlefshme të emailit.",
    PROFILE_IMAGE:"Ju lutemi zgjidhni imazhin e profilit tuaj",
    VALID_PHONE_NUMBER: "Numri i telefonit duhet të jetë së fundi 7 numra.",
    VALID_PHONE: "Ju lutemi shkruani një numër telefoni të vlefshëm",
    PHONE_MAX_CHAR: "Numri i telefonit nuk mund të kalojë më shumë se 15 numra.",
    SelectField: (name: string) => `Ju lutem zgjidhni ${name}`,
    NO_SPACE_ALLOWED: "Hapësira nuk lejohet.",
    PASSWORD_UPPER_CASE: "Fjalëkalimi duhet të përmbajë karaktere alfanumerike që përfshijnë të paktën 1 shkronja të mëdha, 1 të vogla dhe 1 karakter të veçantë.",
    PASSWORD_CONFIRM_PASSWORD_MUST_MATCH: "Fjalëkalimi dhe fjalëkalimi i konfirmimit duhet të jenë të njëjta",



}


export default ValidationMessageAlbanian;

// import React from 'react';
// import { FormattedMessage } from 'react-intl';
// import { capitalizeFirstLetter } from "../../utils/Helper";
// import { ReactNode } from 'react';

// interface ValidationMessages {
//     EMAIL_ADDRESS: ReactNode;
//     ANY_REQUIRED: ReactNode;
//     ANY_SELECT: ReactNode;
//     Field: (name: string) => ReactNode;
//     MinLength: (name: string, length: number) => ReactNode;
//     MaxLength: (name: string, length: number) => ReactNode;
//     // Other fields can be added as necessary
//   }

//   const ValidationMessage: ValidationMessages = {
//     EMAIL_ADDRESS: <FormattedMessage id="email_address"
    
//   };
  

// export default ValidationMessage;

